const state = {
  role: null,
  user: null
};

const mutations = {
  setRole: (state, payload) => {
    state.role = payload.user_role;
  },

  setUserDetails: (state, payload) => {
    state.user = payload;
  }
};

const actions = {};

const getters = {
  role: state => {
    return state.role;
  },
  username: state => state.user
};

export default {
  state,
  mutations,
  actions,
  getters
  // namespaced: true,
};
